var _g, _defs, _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 241,
    viewBox: "0 0 114 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1019_220363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9705 142.879C6.05957 148.743 6.1486 154.604 6.1486 160.456C6.1486 167.002 6.14289 173.548 6.13718 180.093C6.12576 193.176 6.11435 206.253 6.1486 219.307C6.2 225.852 12.2645 232.493 18.9458 232.541C31.9959 232.643 45.0606 232.746 58.1322 232.746C58.2394 232.746 58.3467 232.746 58.454 232.746C69.8305 232.746 81.2121 232.667 92.5937 232.444C103.386 232.252 107.909 227.247 107.961 217.046C107.985 208.256 108.031 199.463 108.077 190.669C108.221 163.018 108.365 135.353 107.858 107.716C107.344 80.0948 97.6303 54.6872 82.6746 31.06C81.6981 29.472 79.0256 28.0284 77.124 27.9803C70.4434 27.86 63.7498 27.7998 57.0563 27.7998C57.0552 27.7998 57.0575 27.7998 57.0563 27.7998C50.3628 27.7998 43.6658 27.86 36.9851 27.9803C35.1863 28.0284 32.668 29.2314 31.7429 30.6269C17.147 53.1473 7.9988 77.5444 6.35418 103.818C5.57428 116.796 5.77247 129.843 5.9705 142.879Z",
    fill: "#EFEDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06832 142.838C8.15375 148.562 8.23914 154.284 8.23914 159.997C8.23914 166.388 8.23366 172.778 8.22819 179.167C8.21723 191.94 8.20629 204.706 8.23914 217.45C8.23914 228.096 14.1052 230.322 20.5134 230.369C33.0304 230.469 45.5613 230.569 58.0987 230.57C58.2016 230.57 58.3045 230.57 58.4074 230.57C69.319 230.569 80.2356 230.493 91.1522 230.275C101.504 230.087 105.891 228.096 105.891 215.242C105.915 206.661 105.959 198.078 106.003 189.493C106.141 162.499 106.279 135.491 105.793 108.51C105.3 81.5449 95.983 56.7408 81.6384 33.6749C80.7018 32.1247 78.1385 30.7153 76.3146 30.6684C69.9069 30.5509 63.4868 30.4922 57.0668 30.4922C50.6468 30.4922 44.2234 30.5509 37.8157 30.6684C36.0904 30.7153 33.675 31.8898 32.7877 33.2521C18.7881 55.2375 10.0137 79.0551 8.43632 104.705C7.68829 117.374 7.87838 130.111 8.06832 142.838Z",
    stroke: "#121212",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1336 6.10642C65.7051 6.10642 74.2766 6.38017 82.8481 5.96954C86.8574 5.76423 88.332 8.29641 88.3781 13.8398C88.6085 36.561 88.9772 33.0022 76.166 33.2075C61.3272 33.4129 46.4883 33.0022 31.6956 33.276C26.7186 33.4129 25.1978 30.5385 25.1978 23.421C25.1978 6.10642 25.0135 6.10642 36.7647 6.10642C43.539 6.10642 50.3132 6.10642 57.1336 6.10642Z",
    fill: "#C30A14",
    stroke: "#850C18",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bottle-liquid",
    x: 1,
    y: 50,
    width: 300,
    height: 180,
    stroke: "none",
    fill: "white",
    clipPath: "url(#liquidClipPath)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1019_220363",
    x: 0.397278,
    y: 0.458496,
    width: 113.235,
    height: 239.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1019_220363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1019_220363",
    result: "shape"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "liquidClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9705 142.879C6.05957 148.743 6.1486 154.604 6.1486 160.456C6.1486 167.002 6.14289 173.548 6.13718 180.093C6.12576 193.176 6.11435 206.253 6.1486 219.307C6.2 225.852 12.2645 232.493 18.9458 232.541C31.9959 232.643 45.0606 232.746 58.1322 232.746H58.454C69.8305 232.746 81.2121 232.667 92.5937 232.444C103.386 232.252 107.909 227.247 107.961 217.046C107.985 208.256 108.031 199.463 108.077 190.669C108.221 163.019 108.365 135.353 107.858 107.716C107.46 86.3422 101.554 66.2939 91.9724 47.3704H22.1002C13.1454 65.1106 7.5993 83.9265 6.35418 103.818C5.57428 116.796 5.77247 129.843 5.9705 142.879Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottle);
export default __webpack_public_path__ + "static/media/bottle.89649be1.svg";
export { ForwardRef as ReactComponent };